import { regexEmail } from 'v3/shared/regex/regexEmail';

export const emailValidator = (email: string): boolean => {
  return regexEmail.test(String(email).toLowerCase());
};

export const breakTextByLength = (value?: string | null, maxCharsPerLine = 22) => {
  if (!value) return '-';

  const text = String(value);
  if (text.length <= maxCharsPerLine) return text;

  const lines: string[] = [];
  for (let i = 0; i < text.length; i += maxCharsPerLine) {
    lines.push(text.slice(i, i + maxCharsPerLine));
  }
  return lines.join('\n');
};
